import React, { useContext, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import PrimaryButton from '../../atoms/PrimaryButton'
import SecondaryButton from '../../atoms/SecondaryButton'
import FullScreenPopup from '../../../components/organisms/FullScreenPopup'
import ProductCommonContext from '../../../context/common/commonContext'
import Box from '@mui/material/Box'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../../common/components'

import { dateFormatFunction } from '../../../../custom/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LinearProgress } from '@mui/material'
import Loaders from '../../molecules/Loaders'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import AuctionContext from '../../../context/auction/auctionContext'
import BaseActionPage from '../../species/dynamic/common/BaseActionPage'
import ProductContext from '../../../context/product/productContext'
import AuthContext from '../../../context/auth/authContext'
import AsinContext from '../../../context/thirdParty/asin/asinContext'
import HomeContext from '../../../context/thirdParty/homeDepot/homeContext'
import XBarContext from '../../../context/thirdParty/xBarCode/xbarContext'
import TemplateContext from '../../../../product/context/template/product/productContext'
import SettingContext from '../../../../product/context/setting/settingContext'
import AlertContext from '../../../../product/context/alert/alertContext'
import { useTranslation } from 'react-i18next'
import ControlHubContext from '@/product/context/controlHub/controlHubContext'
import { useHistory } from 'react-router-dom'
import commonContext from '@/product/context/common/commonContext'
import ManifestContext from '@/product/context/manifest/manifestContext'
import { safeOpenInNewTab } from '@/product/common/urlValidation'

let randomVariable = Math.random()

const ProductFieldsView = (props) => {
    const productContext = useContext(ProductContext)
    const manifestContext = useContext(ManifestContext)
    const auctionContext = useContext(AuctionContext)
    const history = useHistory()
    const settingcontext = useContext(SettingContext)
    const dashboardContext = useContext(commonContext)
    const { getMainDashboardData } = dashboardContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const { t } = useTranslation()
    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const {
        single_manifest,
        getSingleManifest,
        responseStatus: responseStatusManifest,
        clearResponse: clearResponseManifest,
    } = manifestContext

    const {
        projectAction,
        single_project,
        getSingleProject,
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext

    const {
        all_auctions,
        getAllAuctions,
        assignAuctionLot,
        responseStatus: responseStatusAuction,
    } = auctionContext
    const { getGlobalVariable, alldata_all_dropdown, allLocations } =
        useContext(CustomCommonContext)
    const authContext = useContext(AuthContext)
    const asinContext = useContext(AsinContext)
    const homeContext = useContext(HomeContext)
    const xbarContext = useContext(XBarContext)
    const controlHubContext = useContext(ControlHubContext)
    const { getTableDataDynamic, table_data } = controlHubContext
    const { user } = authContext
    const {
        responseStatus: responseHomeDepot,
        all_products: homedepot_products,
        retrieveProduct: retrieveHomeDepot,
        clearResponse: clearResponseHomeDepot,
    } = homeContext

    const {
        responseStatus: responseHomeXBar,
        all_products: xbar_products,
        retrieveProduct: retrieveXBarCode,
        clearResponse: clearResponseXBar,
    } = xbarContext

    const {
        single_project: template_SingleValue,
        getSingleProject: template_GetSingleValue,
    } = useContext(TemplateContext)

    const {
        responseStatus: responseAsin,
        all_products,
        upc_products,
        retrieveUpcProduct,
        retrieveProduct,
        clearResponse: clearResponseAsin,
    } = asinContext
    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [upcDetails, setUpcDetails] = useState({})
    const [asinDetails, setAsinDetails] = useState({})
    const [update, setUpdate] = useState(false)
    const [buttonData, setButtonData] = useState([])
    const [singleManifest, setSingleManifest] = useState({})
    const [allautiondetails, setAllauctions] = useState([])
    const [pluginCountDetails, setPluginCountDetails] = useState(null)
    const [mapDataValue, setMapDataValue] = useState([])
    const [fieldData, setFieldData] = useState([])
    const [resetMapData, setResetMapData] = useState(false)
    const [pluginType, setPluginType] = useState('')
    const [formikValues, setFormikValues] = useState({})
    const [charityData, setCharityData] = useState([])
    const [filterCharity, setFilterCharity] = useState({})
    const [propsFieldValue, setPropsFieldValue] = useState([])
    const [asinValue, setAsinValue] = useState({ record: {} })
    const [homeValue, setHomeValue] = useState({ record: {} })
    const [singleProject, setSingleProject] = useState({ record: {} })

    const mapDataValueRef = useRef(mapDataValue)
    let showPluginCount = global?.showPluginCount
        ? global.showPluginCount
        : props?.showPluginCount
        ? props.showPluginCount
        : []
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])
    const [asinMapData, setAsinMapData] = useState([])
    const [homeMapData, setHomeMapData] = useState([])
    const [xBarMapData, setXBarMapData] = useState([])
    const [upcMapData, setUpcMapData] = useState([])

    useEffect(() => {
        let asinMap = props.fieldValue.filter(
            (item) => item.name === 'asin' && item.active === 1
        )
        let homeMap = props.fieldValue.filter(
            (item) => item.name === 'home_depot' && item.active === 1
        )
        let upcMap = props.fieldValue.filter(
            (item) => item.name === 'upc_id' && item.active === 1
        )
        let xBarCodeMap = props.fieldValue.filter(
            (item) => item.name === 'x_barcode' && item.active === 1
        )

        let projectDynamicArray = props.fieldValue.filter(
            (data) =>
                data.name !== 'asin' &&
                data.name !== 'home_depot' &&
                data.name !== 'upc_id' &&
                data.name !== 'x_barcode' &&
                data.active === 1
        )

        if (props.data?.status === 'new') {
            resetFormikAsin()
            resetFormikHome()
            resetFormikUpc()
            resetFormikXBar()
        } else {
            projectDynamicArray.push({
                name: 'wprice',
                value: '',
                type: 'default',
                active: 1,
            })
        }

        setPropsFieldValue(projectDynamicArray)
        setAsinMapData(asinMap)
        setUpcMapData(upcMap)
        setHomeMapData(homeMap)
        setXBarMapData(xBarCodeMap)
    }, [props.fieldValue, props.data])

    useEffect(() => {
        if (responseAsin && responseAsin.from === randomVariable) {
            if (responseAsin.status === 'error') {
                setIsLoading(false)
                clearResponseAsin()
            }
        }
    }, [responseAsin])

    useEffect(() => {
        if (props?.loading === true || props?.loading === false) {
            setIsLoading(props?.loading)
        }
    }, [props?.loading])

    useEffect(() => {
        if (showPluginCount.length) {
            if (table_data && table_data.records && table_data.records.length) {
                let showData = {}
                table_data.records.map((ele) => {
                    if (ele.payments) {
                        if (showPluginCount.includes(ele.name)) {
                            showData[ele.name] = {
                                limit: ele.max_limit ? ele.max_limit : 0,
                                used: ele.use_count ? ele.use_count : 0,
                                balance: ele.enable
                                    ? ele.max_limit - ele.use_count
                                    : 0,
                                enable: ele.enable,
                                percent: (ele.use_count / ele.max_limit) * 100,
                            }
                        }
                    }
                })
                setPluginCountDetails(showData)
            }
        }
    }, [table_data])
    useEffect(() => {
        if (showPluginCount.length && data?.popup) {
            setPluginCountDetails(null)
            if (props.data?.status === 'new') {
                getTableDataDynamic()
            }
        }
    }, [data?.popup])
    useEffect(() => {
        let customValidationTemp = {}
        let customInitial = {
            id: 0,
            market_status: 'open',
            auctiontype: 'live',
        }
        if (props.customInitialValues) {
            customInitial = { ...customInitial, ...props.customInitialValues }
        }

        customValidationTemp = {
            selltype: Yup.boolean(),
            selectedbuyer: Yup.array().when('selltype', {
                is: (avatar) => avatar,
                then: Yup.array().required('Required!'),
            }),
            date_added: Yup.date(t('Please enter valid Date!'))
                .nullable()
                .typeError(t('Required!'))
                .transform((__, value) =>
                    value && typeof value === 'string'
                        ? new Date(
                              moment(
                                  new Date(value.replace(/-/g, '/'))
                              ).subtract(1, 'minutes')
                          )
                        : new Date(moment(value).subtract(1, 'minutes'))
                )
                .required(t('Required!')),
            date_closed: Yup.date(t('Please enter valid Date!'))
                .typeError(t('Required!'))
                .transform((__, value) =>
                    value && typeof value === 'string'
                        ? new Date(
                              moment(
                                  new Date(value.replace(/-/g, '/'))
                              ).subtract(1, 'minutes')
                          )
                        : new Date(moment(value).subtract(1, 'minutes'))
                )
                .min(
                    Yup.ref('date_added'),
                    t('Should be greater than start Time')
                )
                .nullable(),
            auction: Yup.boolean().when('buynow', {
                is: (e) => !e,
                then: Yup.boolean().oneOf(
                    [true],
                    t('Enable Auction or Buy Now')
                ),
                otherwise: Yup.boolean(),
            }),
            buynow: Yup.boolean().when('auction', {
                is: (e) => !e,
                then: Yup.boolean().oneOf(
                    [true],
                    t('Enable Auction or Buy Now')
                ),
                otherwise: Yup.boolean(),
            }),
            sprice: Yup.number().when('auction', {
                is: true,
                then: Yup.number()
                    .required(t('Required!'))
                    .positive(t('Should be greater than 1')),
            }),
            rprice: props.noReserve
                ? Yup.number().when('reverseauction', {
                      is: true,
                      then: Yup.number()
                          .positive(t('Should be greater than 1'))
                          .max(
                              Yup.ref('sprice'),
                              t(
                                  'Should be equal or less than the starting price'
                              )
                          ),
                      otherwise: Yup.number().when('auction', {
                          is: true,
                          then: Yup.number().when('rprice', {
                              is: (rprice) => rprice > 0,
                              then: Yup.number()
                                  .positive(t('Should be greater than 1'))
                                  .min(
                                      Yup.ref('sprice'),
                                      t(
                                          'Should be equal or greater than the starting price'
                                      )
                                  ),
                              otherwise: Yup.number(),
                          }),
                      }),
                  })
                : Yup.number().when('reverseauction', {
                      is: true,
                      then: Yup.number()
                          .positive(t('Should be greater than 1'))
                          .max(
                              Yup.ref('sprice'),
                              t(
                                  'Should be equal or less than the starting price'
                              )
                          )
                          .required(t('Required!')),
                      otherwise: Yup.number().when('auction', {
                          is: true,
                          then: Yup.number()
                              .positive(t('Should be greater than 1'))
                              .min(
                                  Yup.ref('sprice'),
                                  t(
                                      'Should be equal or greater than the starting price'
                                  )
                              )
                              .required(t('Required!')),
                      }),
                  }),
            bprice: props.noReserve
                ? Yup.number().when('buynow', {
                      is: true,
                      then: Yup.number()
                          .required(t('Required!'))
                          .positive(t('Should be greater than 1'))
                          .when('auction', {
                              is: true,
                              then: Yup.number().when('rprice', {
                                  is: (rprice) => rprice > 0,
                                  then: Yup.number().moreThan(
                                      Yup.ref('rprice'),
                                      t(
                                          'Should be greater than the reserve price'
                                      )
                                  ),
                                  otherwise: Yup.number().moreThan(
                                      Yup.ref('sprice'),
                                      t(
                                          'Should be greater than the starting price'
                                      )
                                  ),
                              }),
                          }),
                  })
                : Yup.number().when('buynow', {
                      is: true,
                      then: Yup.number()
                          .required(t('Required!'))
                          .positive(t('Should be greater than 1'))
                          .when('auction', {
                              is: true,
                              then: Yup.number().moreThan(
                                  Yup.ref('rprice'),
                                  t('Should be greater than the reserve price')
                              ),
                          }),
                  }),
            dimension_length: Yup.number().when('shipping_check', {
                is: true,
                then: Yup.number()
                    .required(t('Required!'))
                    .positive(t('Should be greater than 1')),
            }),
            dimension_width: Yup.number().when('shipping_check', {
                is: true,
                then: Yup.number()
                    .required(t('Required!'))
                    .positive(t('Should be greater than 1')),
            }),
            dimension_height: Yup.number().when('shipping_check', {
                is: true,
                then: Yup.number()
                    .required(t('Required!'))
                    .positive(t('Should be greater than 1')),
            }),
            dimension_unit: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            weight_value: Yup.number().when('shipping_check', {
                is: true,
                then: Yup.number()
                    .required(t('Required!'))
                    .min(1, t('Should be greater than 1'))
                    .positive(t('Should be greater than 1')),
            }),
            station_package_code: Yup.string().when('shipping_check', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            station_warehouse: Yup.string().when('shipping_check', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            qty: Yup.number()
                .integer("Can't be a decimal")
                .required(t('Required!'))
                .positive(t('Should be greater than 0')),
            local_pickup_check: Yup.boolean().when('shipping_check', {
                is: false,
                then: Yup.boolean().oneOf(
                    [true],
                    t('Enable Local Pickup or Shipping')
                ),
            }),
            location_id: Yup.string().when('local_pickup_check', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            local_pickup_slot_timeframe: Yup.number().when(
                'local_pickup_check',
                {
                    is: true,
                    then: Yup.number()
                        .integer(t('Must be an integer'))
                        .min(0, t('Not valid!'))
                        .required(t('Required!')),
                }
            ),
            local_pickup_appt_per_slot: Yup.number().when(
                'local_pickup_check',
                {
                    is: true,
                    then: Yup.number()
                        .integer(t('Must be an integer'))
                        .min(0, t('Not valid!'))
                        .required(t('Required!')),
                }
            ),
            local_pickup_start_hour: Yup.string()
                .nullable()
                .when('local_pickup_check', {
                    is: true,
                    then: Yup.string().nullable().required(t('Required!')),
                }),
            local_pickup_end_hour: Yup.string()
                .nullable()
                .when('local_pickup_check', {
                    is: true,
                    then: Yup.string().nullable().required(t('Required!')),
                }),

            ...props.customValidation,
        }
        setCustomInitialValues(customInitial)
        setCustomValidation(customValidationTemp)
    }, [propsFieldValue, props.customValidation])

    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            let projectValue = {}
            let projectType = 'edit'
            if (
                props.data &&
                props.data?.status &&
                props.data.status === 'edit'
            ) {
                projectValue = single_project.record
                    ? single_project.record
                    : {}
                projectType = 'edit'
            }

            if (
                props.data &&
                props.data?.status &&
                props.data.status === 'manifest'
            ) {
                projectValue = singleManifest.record
                    ? singleManifest.record
                    : {}
                projectType = 'manifest'
            }

            tempMapData.map((mapValue) => {
                if (
                    props?.customDisableFields?.length &&
                    props?.customDisableFields.includes(mapValue?.name) &&
                    projectValue?.bidscount
                ) {
                    mapValue.disabled = true
                }
                if (mapValue.name === 'date_closed') {
                    mapValue.minDate = dateTimeFormatFunction(
                        formikValues.date_added ? formikValues.date_added : null
                    )
                    mapValue.minDateMessage = `Date should not be before minimal date ${dateTimeFormatFunction(
                        formikValues.date_added ? formikValues.date_added : null
                    )}`
                    mapValue.disablePast = true
                } else if (mapValue.name === 'date_added') {
                    mapValue.disablePast = true
                } else if (mapValue.name === 'sprice') {
                    if (props.enableStartPrice) {
                        mapValue.disabled = false
                    } else if (
                        projectValue?.sprice &&
                        projectValue?.bidscount
                    ) {
                        mapValue.disabled = true
                    } else if (!props.disable_sprice) {
                        mapValue.disabled = formikValues.auction ? false : true
                    }
                } else if (mapValue.name === 'rprice') {
                    mapValue.disabled = formikValues.auction ? false : true
                } else if (mapValue.name === 'bprice') {
                    mapValue.disabled = formikValues.buynow ? false : true
                } else if (mapValue.name === 'selectedbuyer') {
                    mapValue.disabled = formikValues.selltype ? false : true
                } else if (props.isBrilliant) {
                    if (mapValue.name === 'deposit_amount') {
                        mapValue.disabled = formikValues.deposit ? false : true
                        mapValue.label = 'Deposit Points'
                        mapValue.placeholder = 'Enter Deposit Points'
                    }
                } else if (mapValue.name === 'dimension_length') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'dimension_width') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'dimension_height') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'dimension_unit') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'weight_value') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'weight_unit') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'origin_zip') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'location_id') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_dates') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_start_hour') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_end_hour') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_appt_per_slot') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_slot_timeframe') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'station_package_code') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'station_warehouse') {
                    mapValue.class = `${
                        formikValues.shipping_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (
                    global?.shopify &&
                    mapValue.name == 'push_to_shopify'
                ) {
                    mapValue.class = `${
                        formikValues.shopify_id ||
                        formikValues.market_status != 'open' ||
                        props?.data?.status != 'edit'
                            ? 'd-none'
                            : ''
                    } col-sm-6 col-6`
                } else if (
                    global?.ebay_listing &&
                    mapValue.name == 'push_to_ebay'
                ) {
                    mapValue.class = `col-sm-6 col-6`
                }
                if (mapValue.name === 'registration_year') {
                    let val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues.manufacturing_year
                    )
                    val = parseInt(val[0]?.description)
                    let regArr = alldata_all_dropdown
                        .filter(
                            (value) =>
                                value.variable === 'registration_year' &&
                                value.level === 0
                        )
                        .sort((a, b) => a.show_order - b.show_order)
                        .map((item) => {
                            let valueChanged = {}
                            valueChanged.show = parseInt(item.description)
                            valueChanged.value = data?.diff_value
                                ? item.value
                                : item.id
                            return valueChanged
                        })
                    regArr = regArr.filter((e) => e.show >= val)
                    mapValue.options = regArr
                }
                if (mapValue.name === 'vehculo_nacionalpdf') {
                    const val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues.accidents
                    )
                    if (val[0]?.description == 'Si') {
                        mapValue.class = 'col-sm-3 col-12'
                        mapValue.disabled = false
                    } else {
                        mapValue.class = 'col-sm-3 col-12 invisible'
                        mapValue.disabled = true
                    }
                }
                if (mapValue.name === 'maintanace_historypdf') {
                    const val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues.maintenance_historysino
                    )
                    mapValue.class = `${
                        val[0]?.description == 'Si'
                            ? ''
                            : 'disabledDropzone invisible'
                    } col-sm-3 col-12`
                }
                if (mapValue.name == 'retail_price' && !global?.showRetail) {
                    mapValue.disabled = true
                }

                if (props.toggleAuctionAndBuynow) {
                    const val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues.select_product_type
                    )
                    if (mapValue.name === 'auction') {
                        mapValue.disabled = formikValues.buynow ? true : false
                    } else if (mapValue.name === 'buynow') {
                        mapValue.disabled = formikValues.auction ? true : false
                    }
                    if (mapValue.name === 'sprice') {
                        if (val[0]?.description == 'Habilitar Subasta') {
                            formikValues.auction = 1
                            mapValue.disabled = false
                        } else {
                            formikValues.auction = 0
                            mapValue.disabled = true
                        }
                        // formikValues.sprice = formikValues.buynow
                        //     ? ''
                        //     : formikValues.sprice
                    }
                    if (mapValue.name === 'rprice') {
                        if (val[0]?.description == 'Habilitar Subasta') {
                            formikValues.auction = 1
                            mapValue.disabled = false
                        } else {
                            formikValues.auction = 0
                            mapValue.disabled = true
                        }
                        // formikValues.rprice = formikValues.buynow
                        //     ? ''
                        //     : formikValues.rprice
                    }
                    if (mapValue.name === 'bprice') {
                        if (val[0]?.description == 'Habilitar Venta directa') {
                            formikValues.buynow = 1
                            mapValue.disabled = false
                        } else {
                            formikValues.buynow = 0
                            mapValue.disabled = true
                        }
                        // formikValues.bprice = formikValues.auction
                        //     ? ''
                        //     : formikValues.bprice
                    }
                    if (mapValue.name == 'tire_manufacturer_spare') {
                        const val = alldata_all_dropdown.filter(
                            (e) => e.id == formikValues.spare_tire
                        )
                        mapValue.disabled =
                            val[0]?.description == 'Si' ? false : true
                        mapValue.class = `${
                            val[0]?.description == 'Si' ? '' : 'invisible'
                        } col-sm-3 col-12`
                    }
                    if (mapValue.name == 'tire_size_spare') {
                        const val = alldata_all_dropdown.filter(
                            (e) => e.id == formikValues.spare_tire
                        )
                        mapValue.disabled =
                            val[0]?.description == 'Si' ? false : true
                        mapValue.class = `${
                            val[0]?.description == 'Si' ? '' : 'invisible'
                        } col-sm-3 col-12`
                    }
                    if (mapValue.name == 'tire_image_spare') {
                        const val = alldata_all_dropdown.filter(
                            (e) => e.id == formikValues.spare_tire
                        )
                        mapValue.class = `${
                            val[0]?.description == 'Si'
                                ? ''
                                : 'disabledDropzone invisible'
                        } col-sm-3 col-12`
                    }
                }
                //  else if (mapValue.name === 'slot_from_time' && props?.data?.status == 'edit') {
                //     formikValues.slot_from_time = reverseTimeFormatFunction(
                //         formikValues.slot_from_time ? `"${formikValues.slot_from_time}" ` : null,
                //     )
                // } else if (mapValue.name === 'slot_end_time' && props?.data?.status == 'edit') {
                //     formikValues.slot_end_time = reverseTimeFormatFunction(
                //         formikValues.slot_end_time ? `"${formikValues.slot_end_time}" ` : null,
                //     )
                // }
            })
            if (!formikValues.local_pickup_check) {
                formikValues.location_id = []
            }
            if (formikValues?.charity_id && formikValues?.charity_id !== '') {
                let data = charityData.filter(
                    (item) => item.fundraiser_id === formikValues?.charity_id
                )
                if (data.length) {
                    setFilterCharity(data[0])
                } else {
                    setFilterCharity({})
                }
            }
            setReload(!reload)
            // setFieldData(tempMapData)
            setTimeout(() => {
                if (projectType === 'edit') {
                    if (tempMapData.length) {
                        setSingleProject(single_project)
                    }
                }

                if (projectType === 'manifest') {
                    if (tempMapData.length) {
                        setSingleProject(singleManifest)
                        // if(single_manifest)
                    }
                }
            }, 2000)

            // setMapDataValue(tempMapData)
            // setResetMapData(true)
        }
    }, [formikValues, single_project, singleManifest, props.data])

    useEffect(() => {
        let manifest_value = {}
        if (Object.keys(single_manifest.record).length) {
            manifest_value = single_manifest
            manifest_value.record.qty = manifest_value?.record?.quantity || 0
            manifest_value.record.asin_id = manifest_value?.record?.asin || 0
            manifest_value.record.brand =
                manifest_value.record.manufacturer_name || ''
            manifest_value.record.desc_proc =
                manifest_value.record.description || ''
            // let categoryValue = manifest_value?.record?.category
            // let categoryChanged = ''
            // if (categoryValue !== '') {
            //     categoryChanged = categoryFilter(categoryValue, 'category')
            // } else {
            //     categoryChanged = ''
            // }
            // manifest_value.record.category = categoryChanged
            manifest_value.record.bprice =
                manifest_value.record.cost_per_unit || 0
            setSingleManifest(manifest_value)
        }
    }, [single_manifest])

    useEffect(() => {
        if (search_fetch_data && mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            if (search_fetch_data.from === 'charity_data') {
                if (search_fetch_data.records.length) {
                    setCharityData(search_fetch_data.records)
                    tempMapData.map((mapValue) => {
                        if (mapValue.name === 'charity_id') {
                            mapValue.options = search_fetch_data.records.map(
                                (data) => {
                                    let busCategoryChanged = {}
                                    busCategoryChanged.show =
                                        data.fundraiser_name
                                    busCategoryChanged.value =
                                        data.fundraiser_id
                                    return busCategoryChanged
                                }
                            )
                        }
                    })
                } else {
                    setCharityData([])
                    tempMapData.map((mapValue) => {
                        if (mapValue.name === 'charity_id') {
                            mapValue.options = []
                        }
                    })
                }
            }
            setReload(!reload)
        }
    }, [search_fetch_data])

    useEffect(() => {
        const projectToShow = []
        if (all_auctions && all_auctions.records.length > 0) {
            all_auctions.records.map((lot) => {
                if (lot.market_status != 'closed')
                    projectToShow.push({ value: lot.id, show: lot.title })
            })
            setAllauctions(projectToShow)
        } else {
            setAllauctions(projectToShow)
        }
    }, [all_auctions])

    useEffect(() => {
        if (responseStatusProduct) {
            if (
                responseStatusProduct.status === 'success' &&
                responseStatusProduct.from === 'projectAction'
            ) {
                if (props.standalone) {
                    setIsLoading(false)
                    props.closeFunction(false)
                    randomVariable = Math.random()
                } else {
                    toggleFullScreenPopup(false)
                    randomVariable = Math.random()
                }
                const filterBody = {
                    filterRange: true,
                    search: 'within',
                    within: 'month',
                }
                getMainDashboardData(
                    global.customDashboardFilter
                        ? { ...global.customDashboardFilter, ...filterBody }
                        : filterBody
                )
            } else if (
                responseStatusProduct.status === 'error' &&
                responseStatusProduct.from === 'projectAction'
            ) {
                setIsLoading(false)
            }
            clearResponseProduct()
        }
    }, [responseStatusProduct])

    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const validationArray = Yup.object({
        asin: Yup.string().required('Required!'),
    })

    const validationHomeArray = Yup.object({
        home_depot: Yup.string().required('Required!'),
    })

    const validationXBarArray = Yup.object({
        x_barcode: Yup.string().required('Required!'),
    })

    const validationUpcArray = Yup.object({
        upc_id: Yup.number().required('Required!'),
    })

    const formikAsin = useFormik({
        initialValues: {
            user_id: user?.admin_id,
            asin: '',
            id: '',
            type: 'asin', // Don't Change Type
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            randomVariable = Math.random()
            setPluginType(values.type)
            values.id = values.asin
            retrieveProduct(values, randomVariable)
            formikHomeDepot.values.home_depot = ''
            formikUpc.values.upc_id = ''
        },
    })
    const formikHomeDepot = useFormik({
        initialValues: {
            user_id: user?.admin_id,
            home_depot: '',
        },
        validateOnBlur: false,
        validationSchema: validationHomeArray,
        onSubmit: (values) => {
            retrieveHomeDepot(values)
            formikAsin.values.asin = ''
            formikUpc.values.upc_id = ''
        },
    })

    const formikXBarCode = useFormik({
        initialValues: {
            user_id: user?.admin_id,
            x_barcode: '',
        },
        validateOnBlur: false,
        validationSchema: validationXBarArray,
        onSubmit: (values) => {
            retrieveXBarCode(values)
            formikAsin.values.asin = ''
            formikUpc.values.upc_id = ''
        },
    })

    const formikUpc = useFormik({
        initialValues: {
            upc_id: '',
            type: 'upc', // Don't Change Type
            id: '',
        },
        validateOnBlur: false,
        validationSchema: validationUpcArray,
        onSubmit: (values) => {
            randomVariable = Math.random()
            setPluginType(values.type)
            values.id = values.upc_id
            retrieveProduct(values, randomVariable)
            setIsLoading(true)
            formikAsin.values.asin = ''
            formikHomeDepot.values.home_depot = ''
        },
    })

    const categoryFilter = (value, fieldname) => {
        if (value) {
            setIsLoading(true)
            let arrayData = [...propsFieldValue]
            let filterValue = ''
            arrayData.map((data, index) => {
                if (data.type === 'select') {
                    if (value !== null) {
                        if (!data.diff_value) {
                            let idValue = {}
                            idValue = alldata_all_dropdown.filter(
                                (item) =>
                                    item.description === `${value}` &&
                                    item.variable === `${fieldname}` &&
                                    item.active == 1
                            )
                            if (idValue.length) {
                                let values = idValue[0]
                                filterValue = values.id
                            }
                        }
                    }
                }
            })
            if (filterValue !== '') {
                return filterValue
            } else {
                if (props?.noAutoCreate) {
                    setAlert('Category not prefilled', 'warning')
                } else {
                    searchTableAction(
                        {
                            id: 0,
                            value: null,
                            description: value,
                            variable: fieldname,
                            table: 'data_all_dropdown',
                            active: 1,
                        },
                        false,
                        'updateDropdown'
                    )
                }
            }
        }
    }

    // const categoryFunction = () =>{

    // }

    useEffect(() => {
        if (responseStatusSetting) {
            if (responseStatusSetting.status === 'success') {
                if (responseStatusSetting.from === 'updateDropdown') {
                    getGlobalVariable()
                    setTimeout(() => {
                        // setReload(!reload)
                        setUpdate(!update)
                    }, 2000)

                    // setReload(!reload)
                    clearResponseCommuncation()
                }
            }
        }
    }, [responseStatusSetting])

    const dimensionFunction = (data) => {
        let arrayData = []
        if (data && data.length) {
            data.map((item) => {
                if (item.key === 'Dimensions') {
                    item.value.map((key) => {
                        var regExp = /\(([^)]+)\)/
                        var matches = regExp.exec(key.name)
                        if (matches.length) {
                            if (matches[1] == 'in.') {
                                arrayData.units = 'inch'
                                if (key.name === 'Product Depth (in.)') {
                                    var txt = key.value
                                    var numb = txt.match(/\d/g)
                                    arrayData.height = numb.join('')
                                } else if (
                                    key.name === 'Product Height (in.)'
                                ) {
                                    var txt = key.value
                                    var numb = txt.match(/\d/g)
                                    arrayData.height = numb.join('')
                                } else if (
                                    key.name === 'Product Length (in.)'
                                ) {
                                    var txt = key.value
                                    var numb = txt.match(/\d/g)
                                    arrayData.length = numb.join('')
                                } else if (key.name === 'Product Width (in.)') {
                                    var txt = key.value
                                    var numb = txt.match(/\d/g)
                                    arrayData.width = numb.join('')
                                }
                            } else {
                                arrayData.units = 'centimeter'
                            }
                        }
                    })
                }
            })
        }

        return arrayData
    }

    const updateCount = (data) => {
        if (showPluginCount.length && showPluginCount.includes(data)) {
            if (pluginCountDetails && pluginCountDetails[data]) {
                let plugin = pluginCountDetails[data]

                let plusCount = parseInt(plugin.used, 10) + 1
                let maxCount = parseInt(plugin.limit, 10)
                let pluginValue = {
                    limit: maxCount,
                    used: plusCount,
                    balance: maxCount <= plusCount ? 0 : maxCount - plusCount,
                    enable: maxCount <= plusCount ? 0 : 1,
                    percent: (plusCount / maxCount) * 100,
                }
                // let newObj=pluginCountDetails

                setPluginCountDetails((ele) => {
                    let temp = { ...ele }
                    temp[data] = pluginValue
                    return temp
                })
            }
        }
    }

    useEffect(() => {
        if (
            all_products.from === randomVariable &&
            Object.keys(all_products.record).length
        ) {
            updateCount(pluginType)
            setAsinDetails(all_products)
            setAlert('Product Retrieved Successfullly', 'success')
            randomVariable = Math.random()
        } else if (all_products.from === randomVariable) {
            setAsinDetails({})
            setIsLoading(false)
            setAlert(all_products.message, 'error')
            randomVariable = Math.random()
        }
    }, [all_products])

    // useEffect(() => {
    //     if (upcDetails?.asin && Object.keys(upcDetails.asin).length) {
    //         let asinFetchValue = upcDetails.asin
    //         let categoryValue = asinFetchValue?.category
    //         let categoryChanged = ''
    //         if (categoryValue) {
    //             categoryChanged = categoryFilter(categoryValue, 'category')
    //         } else {
    //             categoryChanged = ''
    //         }
    //         let asinTempValue = {
    //             record: {
    //                 title: asinFetchValue?.title,
    //                 auction: 1,
    //                 shipping_enable: 1,
    //                 dimension_length: asinFetchValue?.packageDimensions?.length,
    //                 dimension_width: asinFetchValue?.packageDimensions?.width,
    //                 dimension_height: asinFetchValue?.packageDimensions?.height,
    //                 weight_value: asinFetchValue?.packageDimensions?.weight,
    //                 sku: asinFetchValue?.mpn,
    //                 brand: asinFetchValue?.brand,
    //                 upc: asinFetchValue?.upc,
    //                 category: categoryChanged,
    //                 uploadimages: asinFetchValue?.uploadimages,
    //                 auctiontype: 'live',
    //             },
    //         }
    //         let mapData = []
    //         mapData = [...propsFieldValue]
    //         if (mapData.length) {
    //             mapData.map((data, index) => {
    //                 if (data.name === 'auctionid') {
    //                     data.options = allautiondetails ? allautiondetails : []
    //                 }
    //             })
    //         }
    //         let index = mapData.findIndex((e) => e.name === 'buynow')
    //         const array = {
    //             type: 'misc',
    //             content: [
    //                 <a target="_blank" onClick={viewTerms} className="text-danger">
    //                     {`Check Price? - ${
    //                         asinFetchValue?.lowestNewPrice !== null
    //                             ? asinFetchValue?.lowestNewPrice
    //                             : '0'
    //                     }`}
    //                 </a>,
    //             ],
    //             class: 'col-12',
    //             show_order: 7,
    //         }
    //         let orderedArray = addAfter(mapData, index, array)
    //         setFieldData(orderedArray)
    //         setTimeout(() => {
    //             if (orderedArray.length) {
    //                 setAsinValue(asinTempValue)
    //             }
    //         }, 2000)
    //         setIsLoading(false)
    //     } else if (upcDetails?.upc && Object.keys(upcDetails.upc).length) {
    //         let upcFetchValue = upcDetails.upc
    //         let categoryValue = upcFetchValue?.category?.split('>', 1)
    //         let categoryChanged = ''
    //         if (categoryValue.length) {
    //             let category = categoryValue.toString()
    //             categoryChanged = categoryFilter(category, 'category', 'upc')
    //         } else {
    //             categoryChanged = ''
    //         }
    //         console.log(categoryChanged, 'upccateftt')
    //         let asinTempValue = {
    //             record: {
    //                 title: upcFetchValue?.title,
    //                 desc_proc: upcFetchValue?.description,
    //                 auction: 1,
    //                 uploadimages: upcFetchValue?.images?.toString(),
    //                 category: categoryChanged,
    //                 auctiontype: 'live',
    //             },
    //         }
    //         let mapData = []
    //         mapData = [...propsFieldValue]
    //         // let index = mapData.findIndex((e) => e.name === 'buynow')

    //         // let data = ''
    //         // const array = {
    //         //     type: 'misc',
    //         //     content: [
    //         //         <a target="_blank" onClick={() => viewUpc(data)} className="text-danger">
    //         //             {`Check UPC Price? - ${
    //         //                 upcFetchValue?.msrp !== null ? upcFetchValue?.msrp : '0'
    //         //             }`}
    //         //         </a>,
    //         //     ],
    //         //     class: 'col-6 col-xs-12',
    //         //     show_order: 7,
    //         // }

    //         // let orderedArray = addAfter(mapData, index, array)
    //         setFieldData(mapData)
    //         setTimeout(() => {
    //             if (mapData.length) {
    //                 setAsinValue(asinTempValue)
    //             }
    //         }, 2000)
    //         setIsLoading(false)
    //     }
    // }, [upcDetails, update])

    useEffect(() => {
        if (
            homedepot_products.record &&
            Object.keys(homedepot_products.record).length
        ) {
            // let categoryValue = homedepot_products.record?.category
            // let categoryChanged = ''
            // if (categoryValue !== '') {
            //     categoryChanged = categoryFilter(categoryValue, 'category')
            // } else {
            //     categorychanged = ''
            // }
            // let categoryValue = categoryFilter(homedepot_products.record?.category, 'category')
            let dimensionValue = dimensionFunction(
                homedepot_products.record?.product_results?.specifications
            )

            let asinTempValue = {
                record: {
                    title: homedepot_products.record?.product_results?.title,
                    desc_proc:
                        homedepot_products.record?.product_results?.description,
                    auction: 1,
                    brand: homedepot_products.record?.product_results?.brand
                        ?.name,
                    upc: homedepot_products.record?.product_results?.upc,
                    uploadimages:
                        homedepot_products.record?.uploadimages?.toString(),
                    home_id:
                        homedepot_products.record?.product_results?.product_id,
                    shipping_enable: props?.defaultValues?.shipping_enable || 0,
                    local_pickup_check:
                        props?.defaultValues?.local_pickup_check || 0,
                    dimension_unit: dimensionValue.units,
                    dimension_width: dimensionValue.width,
                    dimension_height: dimensionValue.height,
                    dimension_length: dimensionValue.length,
                    auctiontype: 'live',
                    sprice: props?.defaultValues?.sprice || 0,
                    rprice: props?.defaultValues?.rprice || 0,
                    qty: props?.defaultValues?.qty || 0,
                    pick_up_details: props?.configValues?.pick_up_details || '',
                    return_condition_details:
                        props?.configValues?.return_condition_details || '',
                    payment_details: props?.configValues?.payment_details || '',
                },
            }
            let mapData = []
            mapData = [...propsFieldValue]
            let index = mapData.findIndex((e) => e.name === 'buynow')

            let data = homedepot_products.record?.product_results?.link
            const array = {
                type: 'misc',
                content: [
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => viewHomeDepot(data)}
                        className="text-danger"
                    >
                        {`Check HomeDepot Price? - ${
                            homedepot_products.record?.product_results
                                ?.price !== null
                                ? homedepot_products.record?.product_results
                                      ?.price
                                : '0'
                        }`}
                    </a>,
                ],
                class: 'col-6 col-xs-12',
                show_order: 7,
            }

            let orderedArray = addAfter(mapData, index, array)
            setFieldData(orderedArray)
            setTimeout(() => {
                if (orderedArray.length) {
                    setAsinValue(asinTempValue)
                }
            }, 2000)
        }
    }, [homedepot_products])

    useEffect(() => {
        if (xbar_products?.record && Object.keys(xbar_products.record).length) {
            let categoryValue = xbar_products.record?.category
            let categoryChanged = ''
            if (categoryValue !== '') {
                categoryChanged = categoryFilter(categoryValue, 'category')
            } else {
                categoryChanged = ''
            }
            // let categoryValue = categoryFilter(all_products.record?.category, 'category')
            let asinTempValue = {
                record: {
                    title: xbar_products.record?.title,
                    auction: 1,
                    shipping_enable: props?.defaultValues?.shipping_enable || 0,
                    local_pickup_check:
                        props?.defaultValues?.local_pickup_check || 0,
                    dimension_length:
                        xbar_products.record?.packageDimensions?.length,
                    dimension_width:
                        xbar_products.record?.packageDimensions?.width,
                    dimension_height:
                        xbar_products.record?.packageDimensions?.height,
                    weight_value:
                        xbar_products.record?.packageDimensions?.weight,
                    sku: xbar_products.record?.mpn,
                    brand: xbar_products.record?.brand,
                    upc: xbar_products.record?.upc,
                    category: categoryChanged,
                    uploadimages: xbar_products.record?.uploadimages,
                    auctiontype: 'live',
                    asin_price: xbar_products?.record?.lowestNewPrice || 0,
                    asin_id: xbar_products?.record?.asin || 0,
                    sprice: props?.defaultValues?.sprice || 0,
                    rprice: props?.defaultValues?.rprice || 0,
                    qty: props?.defaultValues?.qty || 0,
                    pick_up_details: props.configValues?.pick_up_details || '',
                    return_condition_details:
                        props.configValues?.return_condition_details || '',
                    payment_details: props.configValues?.payment_details || '',
                },
            }
            let mapData = []
            mapData = [...propsFieldValue]
            if (mapData.length) {
                mapData.map((data, index) => {
                    if (data.name === 'auctionid') {
                        data.options = allautiondetails ? allautiondetails : []
                    }
                })
            }
            let index = mapData.findIndex((e) => e.name === 'buynow')
            const array = {
                type: 'misc',
                content: [
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={viewTerms}
                        className="text-danger"
                    >
                        {`Check Price? - ${
                            xbar_products.record?.lowestNewPrice !== null
                                ? xbar_products.record?.lowestNewPrice
                                : '0'
                        }`}
                    </a>,
                ],
                class: 'col-12',
                show_order: 7,
            }
            let orderedArray = addAfter(mapData, index, array)
            setFieldData(orderedArray)
            setTimeout(() => {
                if (orderedArray.length) {
                    setAsinValue(asinTempValue)
                }
            }, 2000)
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 1500)
    }, [xbar_products, update])

    useEffect(() => {
        if (asinDetails?.record && Object.keys(asinDetails.record).length) {
            let categoryValue = asinDetails.record?.category
            let categoryChanged = ''
            if (categoryValue !== '') {
                categoryChanged = categoryFilter(categoryValue, 'category')
            } else {
                categoryChanged = ''
            }
            // let categoryValue = categoryFilter(all_products.record?.category, 'category')
            let asinTempValue = {
                record: {
                    title: asinDetails.record?.title,
                    auction: 1,
                    shipping_enable: props?.defaultValues?.shipping_enable || 0,
                    local_pickup_check:
                        props?.defaultValues?.local_pickup_check || 0,
                    dimension_length:
                        asinDetails.record?.packageDimensions?.length,
                    dimension_width:
                        asinDetails.record?.packageDimensions?.width,
                    dimension_height:
                        asinDetails.record?.packageDimensions?.height,
                    weight_value: asinDetails.record?.packageDimensions?.weight,
                    sku: asinDetails.record?.mpn,
                    brand: asinDetails.record?.brand,
                    upc: asinDetails.record?.upc,
                    category: categoryChanged,
                    uploadimages: asinDetails.record?.uploadimages,
                    auctiontype: 'live',
                    asin_price: asinDetails?.record?.lowestNewPrice || 0,
                    asin_id: asinDetails?.record?.asin || 0,
                    sprice: props?.defaultValues?.sprice || 0,
                    rprice: props?.defaultValues?.rprice || 0,
                    desc_proc:
                        asinDetails?.record?.prod_desc || !props.hideTitleAsDesc
                            ? asinDetails?.record?.title
                            : '',
                    qty: props?.defaultValues?.qty
                        ? props?.defaultValues?.qty
                        : asinDetails?.record?.qty
                        ? asinDetails?.record?.qty
                        : 0,
                    pick_up_details: props.configValues?.pick_up_details || '',
                    return_condition_details:
                        props.configValues?.return_condition_details || '',
                    payment_details: props.configValues?.payment_details || '',
                },
            }
            let mapData = []
            mapData = [...propsFieldValue]
            if (mapData.length) {
                mapData.map((data, index) => {
                    if (data.name === 'auctionid') {
                        data.options = allautiondetails ? allautiondetails : []
                    }
                })
            }
            let index = mapData.findIndex((e) => e.name === 'buynow')
            const array = {
                type: 'misc',
                content: [
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={viewTerms}
                        className="text-danger"
                    >
                        {`Check Price? - ${
                            asinDetails.record?.lowestNewPrice !== null
                                ? asinDetails.record?.lowestNewPrice
                                : '0'
                        }`}
                    </a>,
                ],
                class: 'col-12',
                show_order: 7,
            }
            let orderedArray = addAfter(mapData, index, array)
            setFieldData(orderedArray)
            setTimeout(() => {
                if (orderedArray.length) {
                    setAsinValue(asinTempValue)
                }
            }, 2000)
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 1500)
    }, [asinDetails, update])

    const viewHomeDepot = (data) => safeOpenInNewTab(data)

    const viewUpc = (data) => {
        if (data === '') {
        } else {
            safeOpenInNewTab(data)
        }
    }

    const viewTerms = () => {
        safeOpenInNewTab(
            `https://www.amazon.com/dp/${formikAsin.values.asin}?%2Ftag=auction0f2-20&th=1`
        )
    }
    const addAfter = (array, index, newItem) => {
        return [...array.slice(0, index), newItem, ...array.slice(index)]
    }

    useEffect(() => {
        let mapData = [...propsFieldValue]
        if (mapData.length) {
            mapData.map((data, index) => {
                if (data.name === 'auctionid') {
                    data.options = allautiondetails ? allautiondetails : []
                }
            })
            setFieldData(mapData)
            setReload(!reload)
            setTimeout(() => {
                setIsLoading(false)
            }, 2000)
        }
    }, [propsFieldValue, props.data])

    const asinData = {
        formik: formikAsin,
        data: asinMapData,
    }

    const homeData = {
        formik: formikHomeDepot,
        data: homeMapData,
    }

    const upcData = {
        formik: formikUpc,
        data: upcMapData,
    }

    const xBarData = {
        formik: formikXBarCode,
        data: xBarMapData,
    }

    const resetFormikAsin = () => {
        formikAsin.values.asin = ''
    }

    const resetFormikHome = () => {
        formikHomeDepot.values.home_depot = ''
    }

    const resetFormikXBar = () => {
        formikXBarCode.values.x_barcode = ''
    }

    const resetFormikUpc = () => {
        formikUpc.values.upc_id = ''
    }

    const submitFunction = (data, updatedFormikValues) => {
        const value = updatedFormikValues
        if (data) {
            value.market_status = data
        }
        /* It is for duplicate lot posting */
        if (props?.data?.status === 'duplicate') {
            value.id = 0
            value.market_status = 'draft'
        }

        if (props?.data?.status === 'manifest') {
            value.id = 0
            value.market_status = 'draft'
        }

        if (value?.sale_type) {
            if (value.sale_type === 'auction') {
                value.auctiontype = 'live'
            } else if (value.sale_type === 'sealed') {
                value.auctiontype = 'sealed'
            } else if (value.sale_type === 'sealed_rank') {
                value.auctiontype = 'sealed'
            }
        }

        if (value.reverseauction) {
            value.auctiontype = 'reverse'
        } else {
            value.auctiontype = value.auctiontype || 'live'
        }

        // if (value.market_status === 'draft' && data?.status !== 'duplicate') {
        //     if (value.date_added) {
        //         value.date_added = moment(value.date_added, 'MM-DD-YYYY h:mm a').format()
        //     } else if (value.date_closed) {
        //         value.date_closed = moment(value.date_closed, 'MM-DD-YYYY h:mm a').format()
        //     }
        // }
        if (props.userId) {
            if (props.userId !== null) {
                value.user_id = props.userId
            }
        }
        if (value.slot_date) {
            value.slot_date = dateFormatFunction(value.slot_date)
        }
        if (props.dynamicFieldTable) {
            value.table = props.dynamicFieldTable
        }
        // if (value.slot_from_time) {
        //     value.slot_from_time = timeFormatFunction(value.slot_from_time)
        // }
        // if (value.slot_end_time) {
        //     value.slot_end_time = timeFormatFunction(value.slot_end_time)
        // }
        if (props.shipStation) {
            if (
                props.carrierCode &&
                props.serviceCode &&
                value.shipping_check &&
                !props.dynamicLocation
            ) {
                value.station_service_code = props.serviceCode
                value.station_carrier_code = props.carrierCode
                value.origin_first_name = props.default_address[0] || 'Kirpa'
                value.origin_last_name =
                    props.default_address[1] || 'Unlimited LLC'
                value.origin_phone = props.default_address[2] || ''
                value.origin_email = props.default_address[3] || ''
                value.origin_address1 =
                    props.default_address[4] ||
                    '1802 Industrial Blvd Suite 1010'
                value.origin_country = 'US'
                value.origin_state = props.default_address[5] || 'TX'
                value.origin_city = props.default_address[6] || 'Colleyville'
                value.origin_zip = props.default_address[7] || '76034'
                value.shipping = 'shipStation'
                value.station_package_code = props.station_package_code
                    ? props.station_package_code
                    : ''
                value.station_warehouse = props.station_warehouse
                    ? props.station_warehouse
                    : ''
            } else if (
                props.carrierCode &&
                props.serviceCode &&
                value.shipping_check &&
                props.dynamicLocation &&
                value.lot_location
            ) {
                let filteredLocation = allLocations.filter(
                    (item) => item.id == value.lot_location
                )
                value.station_service_code = props.serviceCode
                value.station_carrier_code = props.carrierCode
                value.origin_first_name = props.default_address[0] || 'Kirpa'
                value.origin_last_name =
                    props.default_address[1] || 'Unlimited LLC'
                value.origin_phone = props.default_address[2] || ''
                value.origin_email = props.default_address[3] || ''
                value.origin_address1 = filteredLocation.length
                    ? filteredLocation[0].address
                    : '1802 Industrial Blvd Suite 1010'
                value.origin_country = 'US'
                value.origin_state = filteredLocation.length
                    ? filteredLocation[0].state
                    : 'TX'
                value.origin_city = filteredLocation.length
                    ? filteredLocation[0].city
                    : 'Colleyville'
                value.origin_zip = filteredLocation.length
                    ? filteredLocation[0].zipCode
                    : '76034'
                value.shipping = 'shipStation'
                value.station_package_code = props.station_package_code
                    ? props.station_package_code
                    : ''
                value.station_warehouse = props.station_warehouse
                    ? props.station_warehouse
                    : ''
            }
        }
        if (props.toggleAuctionAndBuynow) {
            if (value.auction) {
                value.bprice = ''
            } else {
                value.sprice = ''
                value.rprice = ''
            }
        }
        if (props.checkBuynowExclusive) {
            if (!value.auction) {
                value.sprice = 0
                value.rprice = 0
                value.wprice = 0
            }
        }
        if (props?.validate) {
            props.validateFunc(value)
        } else {
            if (!props.loading) {
                setIsLoading(true)
            }

            if (global?.location_equal_location_id) {
                if (value.location) {
                    value.location_id = parseInt(value.location, 10)
                }
            }
            projectAction(value)
        }
    }

    const formSubmit = (value, data) => {
        const updatedFormikValues = {
            ...value,
            market_status: data,
        }

        setFormikValues(updatedFormikValues)
        submitFunction(data, updatedFormikValues)
    }

    const cancelSubmit = () => {
        setIsLoading(false)
        if (props.closeFunction) {
            props.closeFunction()
        } else {
            toggleFullScreenPopup(false, '', 0)
        }

        randomVariable = Math.random()
    }

    useEffect(() => {
        if (data?.status) {
            if (props.getAuction) {
                getAllAuctions({
                    page: 1,
                    limit: 50,
                    order: '',
                    orderby: '',
                    filters: {
                        market_status: {
                            value: 'open',
                            type: 'in',
                            field: 'ac.market_status',
                        },
                    },
                })
            }
        }
    }, [data, props.getAuction])

    const closeFunction = () => {
        setIsLoading(false)
        toggleFullScreenPopup(false, '', 0)
        randomVariable = Math.random()
    }

    useEffect(() => {
        setIsLoading(true)
        if (data?.status !== 'edit') {
            if (data?.status === 'new') {
                resetFormikAsin()
                resetFormikHome()
                setFormikValues({
                    ...formikValues,
                    id: 0,
                })
            }
        }
    }, [data?.id])

    useEffect(() => {
        const buttonDataTemp = []
        if (data && data?.status === 'duplicate') {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: 'Duplicate',
                additionalValue: 'open',
            })
        }
        if (data && data?.status === 'manifest') {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: 'Save as Draft',
                additionalValue: 'draft',
            })
        } else if (data && data?.status === 'use') {
            buttonDataTemp.push({
                type: props.draftValidate ? 'submit' : 'button',
                style: 'secondary',
                label: props.draftValidate ? 'submit' : 'save as draft',
                additionalValue: 'draft',
            })
            if (!props.noSubmitBtn) {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'submit',
                    additionalValue: 'open',
                })
            }
        } else {
            if (formikValues.id) {
                if (formikValues.market_status === 'draft') {
                    buttonDataTemp.push({
                        type: props.draftValidate ? 'submit' : 'button',
                        style: 'secondary',
                        label: props.draftValidate ? 'submit' : 'save as draft',
                        additionalValue: 'draft',
                    })
                    if (!props.noSubmitBtn) {
                        buttonDataTemp.push({
                            type: 'submit',
                            style: 'primary',
                            label: 'submit',
                            additionalValue: 'open',
                        })
                    }
                }
                if (
                    formikValues.market_status === 'open' &&
                    !props.noUpdateBtn
                ) {
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: 'Update',
                        additionalValue: 'open',
                    })
                }
            } else {
                buttonDataTemp.push({
                    type: props.draftValidate ? 'submit' : 'button',
                    style: 'secondary',
                    label: 'save as draft',
                    additionalValue: 'draft',
                })
                if (!props.noSubmitBtn) {
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: 'submit',
                        additionalValue: 'open',
                    })
                }
            }
        }

        setButtonData(buttonDataTemp)
    }, [formikValues.id, formikValues.market_status, data?.status])
    const makePaymentFn = (data) => {
        handleRedirectInternal(history, `billing/${data ? data : 'all'}/0`)
    }
    const ShowBalance = ({ data }) => {
        return data ? (
            <div className="customProgress">
                <LinearProgress
                    variant="determinate"
                    value={data.percent ? data.percent : 0}
                />

                <p className="cpLeft">{`${data.balance} of ${data.limit} Left `}</p>
            </div>
        ) : null
    }
    return props.standalone ? (
        <>
            {isLoading ? (
                <div className="fspLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <>
                    {asinMapData?.length && props.data?.status === 'new' ? (
                        <>
                            <div className="commActBox d-flex justify-content-between align-items-center">
                                <div className="w-100">
                                    <div
                                        // onSubmit={formikAsin.handleSubmit}
                                        className="row flex-wrap d-flex justify-content-start align-items-center"
                                    >
                                        {mapData(asinData)}
                                        {pluginCountDetails &&
                                        pluginCountDetails['asin'] ? (
                                            <ShowBalance
                                                data={
                                                    pluginCountDetails['asin']
                                                }
                                            />
                                        ) : null}
                                        {pluginCountDetails &&
                                        pluginCountDetails['asin'] &&
                                        pluginCountDetails['asin'].enable ==
                                            0 ? (
                                            <div className="col-auto ml-auto btnSearch">
                                                <PrimaryButton
                                                    id="fetch"
                                                    label="Make Payment"
                                                    btnSize="small"
                                                    onClick={() =>
                                                        makePaymentFn('asin')
                                                    }
                                                />
                                            </div>
                                        ) : (
                                            <div className="col-auto ml-auto btnSearch">
                                                <PrimaryButton
                                                    id="fetch"
                                                    label="FETCH"
                                                    btnSize="small"
                                                    onClick={() =>
                                                        formikAsin.handleSubmit()
                                                    }
                                                />
                                            </div>
                                        )}
                                        {/* <div className="col-auto ml-auto btnSearch">
                                            <PrimaryButton
                                                id="fetch"
                                                label="FETCH"
                                                btnSize="small"
                                                type="submit"
                                            />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : null}
                    {homeMapData?.length && props.data?.status === 'new' ? (
                        <>
                            <div className="commActBox d-flex justify-content-between align-items-center">
                                <div className="w-100">
                                    <div
                                        // onSubmit={formikHomeDepot.handleSubmit}
                                        className="row flex-wrap d-flex justify-content-start align-items-center"
                                    >
                                        {mapData(homeData)}
                                        {pluginCountDetails &&
                                        pluginCountDetails['home_depot'] ? (
                                            <ShowBalance
                                                data={
                                                    pluginCountDetails[
                                                        'home_depot'
                                                    ]
                                                }
                                            />
                                        ) : null}
                                        {pluginCountDetails &&
                                        pluginCountDetails['home_depot'] &&
                                        pluginCountDetails['home_depot']
                                            .enable == 0 ? (
                                            <div className="col-auto ml-auto btnSearch">
                                                <PrimaryButton
                                                    id="fetch"
                                                    label="Make Payment"
                                                    btnSize="small"
                                                    onClick={() =>
                                                        makePaymentFn(
                                                            'home_depot'
                                                        )
                                                    }
                                                />
                                            </div>
                                        ) : (
                                            <div className="col-auto ml-auto btnSearch">
                                                <PrimaryButton
                                                    id="fetch"
                                                    label="FETCH"
                                                    btnSize="small"
                                                    onClick={() =>
                                                        formikHomeDepot.handleSubmit()
                                                    }
                                                />
                                            </div>
                                        )}
                                        {/* <div className="col-auto ml-auto btnSearch">
                                            <PrimaryButton
                                                id="fetch"
                                                label="FETCH"
                                                btnSize="small"
                                                type="submit"
                                            />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : null}
                    {xBarMapData?.length && props.data?.status === 'new' ? (
                        <>
                            <div className="commActBox d-flex justify-content-between align-items-center">
                                <div className="w-100">
                                    <div
                                        // onSubmit={formikXBarCode.handleSubmit}
                                        className="row flex-wrap d-flex justify-content-start align-items-center"
                                    >
                                        {mapData(xBarData)}
                                        {pluginCountDetails &&
                                        pluginCountDetails['x_bar_code'] ? (
                                            <ShowBalance
                                                data={
                                                    pluginCountDetails[
                                                        'x_bar_code'
                                                    ]
                                                }
                                            />
                                        ) : null}
                                        {pluginCountDetails &&
                                        pluginCountDetails['x_bar_code'] &&
                                        pluginCountDetails['x_bar_code']
                                            .enable == 0 ? (
                                            <div className="col-auto ml-auto btnSearch">
                                                <PrimaryButton
                                                    id="fetch"
                                                    label="Make Payment"
                                                    btnSize="small"
                                                    onClick={() =>
                                                        makePaymentFn(
                                                            'x_bar_code'
                                                        )
                                                    }
                                                />
                                            </div>
                                        ) : (
                                            <div className="col-auto ml-auto btnSearch">
                                                <PrimaryButton
                                                    id="fetch"
                                                    label="FETCH"
                                                    btnSize="small"
                                                    onClick={() =>
                                                        formikXBarCode.handleSubmit()
                                                    }
                                                />
                                            </div>
                                        )}
                                        {/* <div className="col-auto ml-auto btnSearch">
                                            <PrimaryButton
                                                id="fetch"
                                                label="FETCH"
                                                btnSize="small"
                                                type="submit"
                                            />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : null}
                    {upcMapData?.length && props.data?.status === 'new' ? (
                        <>
                            <div className="commActBox d-flex justify-content-between align-items-center">
                                <div className="w-100">
                                    <div
                                        // onSubmit={formikUpc.handleSubmit}
                                        className="row flex-wrap d-flex justify-content-start align-items-center"
                                    >
                                        {mapData(upcData)}
                                        {pluginCountDetails &&
                                        pluginCountDetails['upc'] ? (
                                            <ShowBalance
                                                data={pluginCountDetails['upc']}
                                            />
                                        ) : null}
                                        {pluginCountDetails &&
                                        pluginCountDetails['upc'] &&
                                        pluginCountDetails['upc'].enable ==
                                            0 ? (
                                            <div className="col-auto ml-auto btnSearch">
                                                <PrimaryButton
                                                    id="fetch"
                                                    label="Make Payment"
                                                    btnSize="small"
                                                    onClick={() =>
                                                        makePaymentFn('upc')
                                                    }
                                                />
                                            </div>
                                        ) : (
                                            <div className="col-auto ml-auto btnSearch">
                                                <PrimaryButton
                                                    id="fetch"
                                                    label="FETCH"
                                                    btnSize="small"
                                                    onClick={() => {
                                                        formikUpc.handleSubmit()
                                                    }}
                                                />
                                            </div>
                                        )}
                                        {/* <div className="col-auto ml-auto btnSearch">
                                            <PrimaryButton
                                                id="fetch"
                                                label="FETCH"
                                                btnSize="small"
                                                type="submit"
                                            />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : null}
                    <BaseActionPage
                        arrayValue={fieldData}
                        data={props.data}
                        reloadData={props?.reloadData}
                        additionalFormikUpdate={additionalFormikUpdate}
                        editFunction={getSingleProject}
                        editManifestFunction={getSingleManifest}
                        editValue={singleProject}
                        handleMapDataValue={handleMapDataValue}
                        actionFunction={formSubmit}
                        cancelFunction={cancelSubmit}
                        buttonAction={buttonData}
                        permission={props.permission}
                        customValidation={customValidation}
                        draftValidation={props.draftValidation}
                        customInitialValues={customInitialValues}
                        showasin={
                            asinMapData?.length
                                ? props.data?.status === 'new'
                                    ? true
                                    : false
                                : false
                        }
                        homeDepot={
                            homeMapData?.length
                                ? props.data?.status === 'new'
                                    ? true
                                    : false
                                : false
                        }
                        xBarCode={
                            xBarMapData?.length
                                ? props.data?.status === 'new'
                                    ? true
                                    : false
                                : false
                        }
                        all_products={asinValue}
                        setrprice={props.setrprice}
                        customDynamicInput={
                            props.customDynamicInput
                                ? props.customDynamicInput
                                : false
                        }
                        customInBetween={props.customInBetween}
                        dynamicFieldTable={props.dynamicFieldTable}
                        isDelete={props.isDelete}
                        validationPopup={props.validationPopup}
                        template_GetSingleValue={template_GetSingleValue}
                        template_SingleValue={template_SingleValue}
                    />
                </>
            )}
        </>
    ) : (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? props.addModaltitle
                        ? props.addModaltitle
                        : t('ADD NEW LISTING')
                    : data?.status === 'duplicate'
                    ? t('Edit Duplicate Lot')
                    : props.editModaltitle
                    ? props.editModaltitle
                    : t(`Edit Listing`)
            }
            open={
                data.status === 'new' ||
                data.status === 'manifest' ||
                data.status === 'edit' ||
                data.status === 'duplicate' ||
                data.status === 'use'
                    ? data.popup
                    : false
            }
            handleClose={() => {
                closeFunction()
            }}
        >
            <div className="addUserModal addListing">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            {asinMapData?.length &&
                            props.data?.status === 'new' ? (
                                <>
                                    <div className="commActBox d-flex justify-content-between align-items-center">
                                        <div className="w-100">
                                            <div className="row flex-wrap d-flex justify-content-start align-items-center">
                                                {mapData(asinData)}
                                                {pluginCountDetails &&
                                                pluginCountDetails['asin'] ? (
                                                    <ShowBalance
                                                        data={
                                                            pluginCountDetails[
                                                                'asin'
                                                            ]
                                                        }
                                                    />
                                                ) : null}
                                                {pluginCountDetails &&
                                                pluginCountDetails['asin'] &&
                                                pluginCountDetails['asin']
                                                    .enable == 0 ? (
                                                    <div className="col-auto ml-auto btnSearch">
                                                        <PrimaryButton
                                                            id="fetch"
                                                            label="Make Payment"
                                                            btnSize="small"
                                                            onClick={() =>
                                                                makePaymentFn(
                                                                    'asin'
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="col-auto ml-auto btnSearch">
                                                        <PrimaryButton
                                                            id="fetch"
                                                            label="FETCH"
                                                            btnSize="small"
                                                            onClick={() =>
                                                                formikAsin.handleSubmit()
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                            {homeMapData?.length &&
                            props.data?.status === 'new' ? (
                                <>
                                    <div className="commActBox d-flex justify-content-between align-items-center">
                                        <div className="w-100">
                                            <form
                                                onSubmit={
                                                    formikHomeDepot.handleSubmit
                                                }
                                                className="row flex-wrap d-flex justify-content-start align-items-center"
                                            >
                                                {mapData(homeData)}

                                                <div className="col-auto ml-auto btnSearch">
                                                    <PrimaryButton
                                                        id="fetch"
                                                        label="FETCH"
                                                        btnSize="small"
                                                        type="submit"
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                            {upcMapData?.length &&
                            props.data?.status === 'new' ? (
                                <>
                                    <div className="commActBox d-flex justify-content-between align-items-center">
                                        <div className="w-100">
                                            <div className="row flex-wrap d-flex justify-content-start align-items-center">
                                                {mapData(upcData)}
                                                {pluginCountDetails &&
                                                pluginCountDetails['upc'] ? (
                                                    <ShowBalance
                                                        data={
                                                            pluginCountDetails[
                                                                'upc'
                                                            ]
                                                        }
                                                    />
                                                ) : null}
                                                {pluginCountDetails &&
                                                pluginCountDetails['upc'] &&
                                                pluginCountDetails['upc']
                                                    .enable == 0 ? (
                                                    <div className="col-auto ml-auto btnSearch">
                                                        <PrimaryButton
                                                            id="fetch"
                                                            label="Make Payment"
                                                            btnSize="small"
                                                            onClick={() =>
                                                                makePaymentFn(
                                                                    'upc'
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="col-auto ml-auto btnSearch">
                                                        <PrimaryButton
                                                            id="fetch"
                                                            label="FETCH"
                                                            btnSize="small"
                                                            onClick={() => {
                                                                formikUpc.handleSubmit()
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                            <BaseActionPage
                                arrayValue={fieldData}
                                data={props.data}
                                additionalFormikUpdate={additionalFormikUpdate}
                                reloadData={props?.reloadData}
                                editFunction={getSingleProject}
                                editManifestFunction={getSingleManifest}
                                editValue={singleProject}
                                handleMapDataValue={handleMapDataValue}
                                actionFunction={formSubmit}
                                cancelFunction={cancelSubmit}
                                permission={props.permission}
                                buttonAction={buttonData}
                                draftValidation={props.draftValidation}
                                customValidation={customValidation}
                                customInitialValues={customInitialValues}
                                showasin={
                                    asinMapData?.length
                                        ? props.data?.status === 'new'
                                            ? true
                                            : false
                                        : false
                                }
                                homeDepot={
                                    homeMapData?.length
                                        ? props.data?.status === 'new'
                                            ? true
                                            : false
                                        : false
                                }
                                xBarCode={
                                    xBarMapData?.length
                                        ? props.data?.status === 'new'
                                            ? true
                                            : false
                                        : false
                                }
                                all_products={asinValue}
                                template_SingleValue={template_SingleValue}
                                template_GetSingleValue={
                                    template_GetSingleValue
                                }
                                setrprice={props.setrprice}
                                customDynamicInput={
                                    props.customDynamicInput
                                        ? props.customDynamicInput
                                        : false
                                }
                                customInBetween={props.customInBetween}
                                dynamicFieldTable={props.dynamicFieldTable}
                                isDelete={props.isDelete}
                                validationPopup={props.validationPopup}
                                // mapDataValue={mapDataValue}
                                // resetMapData={resetMapData}
                                // setResetMapData={setResetMapData}
                            />

                            {/* </form> */}
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default ProductFieldsView
